<template>
  <v-card
    id="confirm-cancel-modal"
    class="main-bg"
    style="background-color: white"
  >
    <v-toolbar class="elevation-1 white" light max-height="64">
      <v-toolbar-title class="black--text"
        ><h3>{{ title }}</h3></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn
        class="mx-2"
        dark
        depressed
        height="36"
        color="primary"
        @click="onSubmit()"
        >ยืนยัน</v-btn
      >
      <v-btn icon @click="onCancel()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="flex-grow-1" style="padding: 40px 24px">
      <v-form @submit.prevent="validate" ref="cancelledForm">
        <v-container fluid class="pa-0">
          <v-row dense>
            <v-col cols="12" md="12">
              <span class="fs-bold-14 black--text"
                >เลือกเหตุผลในการปฏิเสธงาน</span
              >
            </v-col>
            <v-col cols="12" md="12">
              <v-select
                label="เลือก*"
                v-model="input"
                :items="bookingSettingsCancelReasons"
                item-text="display"
                background-color="#FAFAFA"
                @change="requestData.reason = null"
                :rules="[rules.requiredObject('เหตุผลในการปฏิเสธงาน')]"
                return-object
                clearable
                filled
              ></v-select>
            </v-col>
          </v-row>

          <v-row dense v-if="input?.code === 'OTHER'">
            <v-col cols="12" md="12">
              <v-textarea
                label="ระบุเหตุผล*"
                v-model="requestData.reason"
                counter="200"
                background-color="#FAFAFA"
                :rules="[
                  rules.required('เหตุผล', 200),
                  rules.maxLengthOptional(200),
                ]"
                filled
                required
              />
            </v-col>
          </v-row>

          <!-- <v-row>
          <v-col cols="12" md="6">
            <span style="font-size: 16px;">{{ description }}</span>
          </v-col>
          <v-col cols="12" md="12">
            <v-text-field v-model="cancelReason" :rules="rules.cancelReason" label="เหตุผลการปฏิเสธงาน*" filled></v-text-field>
          </v-col>
        </v-row> -->

          <!-- <v-card-actions class="pr-0 pt-10">
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2 py-2"
            x-large
            depressed
            outlined
            height="44"
            color="#D80000"
            @click="onCancel()"
            >ยกเลิก</v-btn
          >
          <v-btn
            class="py-2"
            dark
            x-large
            depressed
            height="44"
            color="#D80000"
            @click="onSubmit()"
            >ยืนยัน</v-btn
          >
        </v-card-actions> -->
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { ERROR } from "@/store/actions/ui";
const ERROR_TEXT = 'กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง';

export default {
  computed: {
     ...mapGetters(["bookingItem", "bookingLoading", "bookingSettingsCancelReasons"]),
    getErrorText() {
      return ERROR_TEXT;
    },
  },
  watch: {},
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    confirmDisplayHeader: {
      type: String
    },
  },
  data() {
    return {
      input: null,
      requestData: {
        reasonId: null,
        reason: null,
      },
      rules: {
        required: (fieldName, max) => (v) => {
          if (!v || v?.trim() === "") {
            return `กรุณาระบุ ${fieldName}`;
          }
          if (max && v.length > max) {
            return `${fieldName} ต้องไม่เกิน ${max} ตัวอักษร`;
          }
          return true;
        },
        requiredObject: (fieldName) => (v) => {
          if (
            !v ||
            typeof v !== "object" ||
            Array.isArray(v) ||
            Object.keys(v).length === 0
          ) {
            return `กรุณาระบุ ${fieldName}`;
          }
          return true;
        },
        maxLength: (max) => (v) =>
          (v && v.length <= max) || `ระบุได้มากสุด ${max} ตัวอักษร`,
        maxLengthOptional: (max) => (v) => {
          if (!v) return true;
          return v.length <= max ? true : `ระบุได้มากสุด ${max} ตัวอักษร`;
        },
      },
    };
  },
  async created() {
    // console.log('data', this.data);
    // await this.$store.dispatch(COMMERCIAL_SERVICE_VENDOR_RATING_REQUEST, this.data.objectId);
    // this.selectedChangedStatus = null;
  },
  methods: {
    onCancel() {
      this.$emit("cancelled");
    },
    async onSubmit() {
      const payload = await this.validate();
      if (payload) {
        console.log('payload', payload);
        this.$emit("saved", payload);
      }
    },
    async validate() {
      let isError = false;
      const payload = this.requestData;
      const formIsValid = await this.$refs.cancelledForm.validate();

      if (!formIsValid) {
        console.log('Form is invalid');
        const formInputs = this.$refs.cancelledForm.inputs;
        console.log('formInputs', formInputs);

        const errorList = [];
        // eslint-disable-next-line array-callback-return
        const errorFound = formInputs.some((input) => {
          console.log('input.errorBucket', input.errorBucket);
          if (input.errorBucket.length > 0) {
            errorList.push(input.errorBucket[0]);
            // this.$store.dispatch(ERROR, input.errorBucket[0]);
          }
        });

        console.log('errorList', errorList);

        if (errorList.length > 0) {
          isError = true;
          // this.$store.dispatch(ERROR, this.getErrorText);
          // return null;
        }

        if (errorFound) {
          console.log('Error dispatched, iteration stopped.');
          return null;
        }
      }

      if (isError) {
        this.$store.dispatch(ERROR, this.getErrorText);
        this.$forceUpdate();
        return null;
      }

      if (payload) {
        payload.reasonId = this.input?.cancelReasonId;
      }

      return payload;
    },
  },
};
</script>
<style lang="scss" scoped>
#confirm-cancel-modal {
  .fs-bold-14 {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
}
</style>
